import { useEffect } from 'react';

import { PlayerAPI } from 'bitmovin-player/modules/bitmovinplayer-core';

import { PlayerProps } from 'components/Player/types.ts';

export default (player: PlayerAPI | null, volume: PlayerProps['volume']) => {
    useEffect(() => {
        if (typeof volume === 'number' && player) {
            player.setVolume(volume * 100);
        }
    }, [player, volume]);
};
